
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/role-booklets",
      function () {
        return require("private-next-pages/role-booklets.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/role-booklets"])
      });
    }
  